// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"_3SNQ0dlFOVaqLytr2WUOz9","success":"ISZ70giEfAe5Ub8Qk-0p3","error":"_1EAN0XICVaFA_htwMjEWqm"};